import { render, staticRenderFns } from "./SubgroupItineraryItemDetailForm.vue?vue&type=template&id=94de69f2&"
import script from "./SubgroupItineraryItemDetailForm.vue?vue&type=script&lang=js&"
export * from "./SubgroupItineraryItemDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports